import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import _ from 'lodash';

import MomentPropTypes from "../../helpers/MomentPropTypes";

import DateModal from './DateModal';
import PureRenderComponent from '../PureRenderComponent';
import TrackingActions from "../../actions/TrackingActions";


class DateSummary extends PureRenderComponent {

    static propTypes = {
        selected: MomentPropTypes.isMoment,
        onChange: PropTypes.func,
        min: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        modalTitle: PropTypes.string,
        children: PropTypes.any,
        srOnly: PropTypes.string,
        focused: PropTypes.bool,
    };

    static defaultProps = {
        onChange: _.noop,
        modalTitle: 'form.dateModal.selectDate',
        selected: moment(),
        max: moment(),
        min: moment('1970-01-01'),
        srOnly: null,
        focused: false,
    };

    state = {
        modalOpen: false
    };

    componentDidUpdate () {
        if (this.props.focused) {
            this.refs.button.focus();
        }
    }

    _toggleModal = () => {
        this.setState({ modalOpen: !this.state.modalOpen });
    };

    _handleSelect = (date) => {
        TrackingActions.widgetDaySelect({date});
        this.props.onChange(date);
        this._toggleModal();
    };

    _renderModal () {
        if (!this.state.modalOpen) {
            return null;
        }
        return (
            <DateModal
                show={ this.state.modalOpen }
                selected={ this.props.selected }
                onCancel={ this._toggleModal }
                onSelect={ this._handleSelect }
                { ..._.omit(this.props, [ 'onChange' ]) }
            />
        );
    }

    render () {
        const { children, selected, srOnly } = this.props;

        return (
            <React.Fragment>
                { this._renderModal() }
                <button
                    className="btn-box"
                    id="loadDateSelect"
                    onClick={ this._toggleModal }
                    ref="button"
                >
                    { srOnly && <span className='sr-only'>{ srOnly }</span> }
                    { children || selected.format('Do MMMM YYYY') }
                </button>
            </React.Fragment>
        );
    }

}

export default DateSummary;



// WEBPACK FOOTER //
// ./src/components/form/DateSummary.js